import { FaInstagram } from "react-icons/fa";

const Contact = () => (
  <section id="contact">
    <div className="max-w-7xl rounded-2xl mx-auto p-4 sm:p-6 lg:p-8">
      <div className="mb-16 text-center">
        <h3 className="mt-2 pb-4 text-4xl lg:text-6xl font-normal uppercase tracking-[0.2em] text-h-gold">
          Contact Us
        </h3>
        <p className="text-h-gold leading-loose">
          Tel:{" "}
          <a className="text-h-gold leading-loose underline decoration-1 underline-offset-4" href="https://wa.link/4ryenn">
            +971 058 586 4996
          </a>
        </p>
        <p className="text-h-gold leading-loose">
          Email:{" "}
          <a
            className="text-h-gold leading-loose underline decoration-1 underline-offset-4"
            href="mailto:Projects@HProjects.me"
          >
            Projects@HProjects.me
          </a>
        </p>
        <p className="text-h-gold leading-loose">
          Address:{" "}
          <a
            className="text-h-gold leading-loose"
            href="https://maps.app.goo.gl/cghCBpkD2Xmd9Eny7"
          >
            Office 202, Building C, Al Saaha offices, Souk Al Bahar, Downtown
            Dubai
          </a>
        </p>
        <a
          href="https://www.instagram.com/hprojectsdubai"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-h-gold leading-loose mt-4 hover:opacity-70"
        >
          <FaInstagram size={24} /> @hprojectsdubai
        </a>
      </div>
    </div>
  </section>
);

export default Contact;
